import { ShopAPIList, ProductAPIList } from '@/api'
import Cookies from 'js-cookie'

const api = new ShopAPIList();
const productAPI = new ProductAPIList();

export default {

  getCategoryList({ state, commit }, param = {}) {
    return new Promise((resolve, reject) => {
      api.getCategoryList(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        commit('setCategoryList', { list: json.data });
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },

  getKOLProducts({ state, commit }, param = {}) {
    return new Promise((resolve, reject) => {
      api.getKOLProducts(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        commit('setKOLProducts', { list: json.data.list });
        commit('setKOLPackages', { list: json.data.groupBuy });
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },

  deleteProduct({ state, dispatch }, param) {
    return new Promise((resolve, reject) => {
      productAPI.deleteProduct(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        let params = {
          count: 10,
          orderby: 'ID',
          link: Cookies.get('shopLink'),
          categoryID:0,
          region:Cookies.get('region'),
          loadGroupBuy:1
        }
        dispatch('getKOLProducts', params);
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },
  deletePackages({ state, dispatch }, param) {
    return new Promise((resolve, reject) => {
      productAPI.deletePackages(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        let params = {
          count: 10,
          orderby: 'ID',
          link: Cookies.get('shopLink'),
          categoryID:0,
          region:Cookies.get('region'),
          loadGroupBuy:1
        }
        dispatch('getKOLProducts', params);
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },

  getKOLProductDetail({ state, dispatch }, param) {
    return new Promise((resolve, reject) => {
      api.getKOLProductDetail(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },
  getKOLPackagesDetail({ state, dispatch }, param) {
    return new Promise((resolve, reject) => {
      api.getKOLPackagesDetail(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },
  stickTop({ state, dispatch }, param) {
    return new Promise((resolve, reject) => {
      api.stickTop(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        let params = {
          count: 10,
          link: Cookies.get('shopLink'),
          categoryID:0,
          region:Cookies.get('region'),
          loadGroupBuy:1
        }
        dispatch('getKOLProducts', params);
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/Shop/store/actions.js